'use client';
import React, { useRef } from 'react';
import { useS7SmartCrop } from './Image.hook.mjs';

const SmartCropS7Enhancer = ({ children }) => {
  const ref = useRef(null);
  useS7SmartCrop(ref);
  return React.cloneElement(children, { ref });
};

export { SmartCropS7Enhancer };
